export const GET_DISCOUNT_PENALTY_LIST =
  'DISCOUNT_PENALTY/get_discount_penalty_list';
export const UPDATE_DISCOUNT_PENALTY =
  'DISCOUNT_PENALTY/update_discount_penalty';

export const GET_FEE_CODES = 'GET_FEE_CODES/get_fee_codes';
export const GET_FEE_SETTINGS = 'GET_FEE_SETTINGS/get_fee_settings';
export const UPDATE_FEE_SETTINGS = 'UPDATE_FEE_SETTINGS/update_fee_settings';

export const FORM_DATA = {
  additional_monthly_penalty_percentage: '',
  date_before_penalty_start: '',
  discount_percentage: '',
  initial_penalty_percentage: '',
  last_date_with_discount: '',
  maximum_penalty_percentage: '',
  month_day_before_penalty_update: '',
  year: '',
  gross_additional_percentage: '',
};
